<ng-container *ngIf="agInitParams as params">
  <div class="create-panel">
    <button nf-button="primary" (click)="createNewFilterGroup()">
      Save Filter Group
    </button>
    <hs-filter-group-import-button
      (createFromFilterGroupPrefix)="cloneFilterGroup($event, params)"
    ></hs-filter-group-import-button>
  </div>
  <div class="tool-panel search-panel">
    <nf-form-control compact>
      <nf-search [formControl]="search"></nf-search>
    </nf-form-control>
  </div>
  <div class="saved-grids-list-panel" *ngIf="filteredFilterGroups as groups">
    <hs-filter-group-card
      *ngFor="let group of groups"
      [filterGroup]="group"
      [cacheLoaded]="params.cacheLoaded | async"
      (triggerUpdateFilters)="updateFilters($event, params)"
      (updateFilterGroup)="updateFilterGroup($event)"
      (deleteFilterGroup)="deleteFilterGroup($event, params)"
      (cloneFilterGroup)="cloneFilterGroup($event.filterGroupPrefix, params)"
      (applyFilterGroup)="applyFilterGroup($event, params)"
      (copyFilterGroupPrefix)="onCopyFilterGroupUUID($event)"
    ></hs-filter-group-card>
  </div>
</ng-container>
